import Cookies from 'js-cookie';
(function ($) {

    function check_for_alert_updates()
    {
        const $alert_block = document.querySelector('.alerte-banner');
        if (!$alert_block) {
            return;
        }
        const block_data = $alert_block.dataset.blockData;
        let minute = new Date;
        minute.setSeconds(0);
        minute.setMilliseconds(0);

        let request = new XMLHttpRequest();
        request.open('GET', ajaxurl+'?action=activis_alerte_banner_refresh&time='+minute.toISOString()+'&block_data='+encodeURIComponent(block_data), true);
        request.onload = function() {
            const response = JSON.parse(this.responseText);
            if (response.success) {
                let $new_alert_block = document.createElement('div');
                $new_alert_block.innerHTML = response.data.content;
                $new_alert_block.style.position = 'fixed';
                $new_alert_block.style.top = '0';
                $new_alert_block.style.left = '0';
                $new_alert_block.style.width = '100%';
                $new_alert_block.style.visibility = 'hidden';
                $new_alert_block.style.pointerEvents = 'none';
                $alert_block.before($new_alert_block);
                const alerts = $new_alert_block.querySelectorAll('.alerte-banner__item');
                if (alerts) {
                    for (var i = 0; i < alerts.length; ++i) {
                        let $el = alerts[i];
                        let id =  $el.id ;
                        if (Cookies.get('#'+id) != 'true') {
                            $el.style.display = 'flex';
                        }else{
                            $el.classList.add('alerte-banner--is-closed');
                        }
                    }
                }

                $alert_block.innerHTML = $new_alert_block.querySelector('.alerte-banner').innerHTML;
                $new_alert_block.remove();
                check_alerts_state();

                setTimeout(check_for_alert_updates, 60000);
            } else {
                console.error(response.data.message);
                setTimeout(check_for_alert_updates, 5000);
            }
        }
        request.onerror = function() {
            console.error(this.responseText);
            setTimeout(check_for_alert_updates, 5000);
        };
        request.send();
    }
    function check_alerts_state(){
        let remove_alerts_overlay = true;
        $('.alerte-banner__item').each(function() {
            if(!$(this).hasClass('alerte-banner--is-closed')){
                remove_alerts_overlay = false;
            }
        })
        if(remove_alerts_overlay){
            $('.alerte-banner').removeClass('alerte-banner--has-alerts-open');
        }else{
            $('.alerte-banner').addClass('alerte-banner--has-alerts-open');
        }
    }

    $(document).ready(function () {
        setTimeout(check_for_alert_updates, 1500);
        $('.alerte-banner').on('click', '.alerte-banner__close', function () {
            let alerte = $(this).parents('.alerte-banner__item').attr('id');
            close_alerte(alerte);
        });
        $('.alerte-banner__item').each(function() {
            let id =  this.id ;
            console.log(Cookies.get('#'+id));
            if (Cookies.get('#'+id) != "true") {
                console.log('Current show : '+id);
                setTimeout(function () {
                    open_alerte(id);
                }, 500);

            }else{
                console.log('Current hide : '+id);
                $('#'+id).addClass('alerte-banner--is-closed');
                $(this).css("display", "flex").hide();
            }

        });
        check_alerts_state();

        function open_alerte (alerte_name) {
            let alerte = $('#'+alerte_name);
            alerte
                .css("display", "flex")
                .hide()
                .fadeIn();
        }

        function close_alerte (alerte_name) {
            let alerte = $('#'+alerte_name);
            alerte.fadeOut();
             Cookies.set('#'+alerte_name, true, { expires: 1, path: '/' });
            alerte.addClass('alerte-banner--is-closed');
            check_alerts_state();
        }

    });
})(jQuery);
